export * from './alias.store';
import { AliasStoreService } from './alias.store';
import { RoleStoreService } from './roles.store';
import { ActionByStoreService } from './actionBy.store';
import { PriorityStoreService } from './priority.store';
import { DisciplineStoreService } from './discipline.store';
import { LocationProjectStoreService } from './location-project.store';
import { TagsStoreService } from './tags.store';
import { InspectionTypeStoreService } from './inspection-types.store';
import { StatusStoreService } from './status.store';
import { SourcesStoreService } from './sources.store';
import { LiveReportsStoreService } from './live-reports.store';
import { TemplateTypeStoreService } from './template-type.store';
import { PunchesTemplatesStoreService } from './punches-templates.store';
import { StatusInspectionStoreService } from './status-inspection.store';
import { NodeLevelStoreService } from './node-level.store';
import { SubcontractorStoreService } from './subcontractor.store';
import { UnitStoreService } from './unit.store';
export * from './roles.store';
export * from './actionBy.store';
export * from './priority.store';
export * from './discipline.store';
export * from './location-project.store';
export * from './tags.store';
export * from './inspection-types.store';
export * from './status.store';
export * from './sources.store';
export * from './live-reports.store';
export * from './template-type.store';
export * from './punches-templates.store';
export * from './status-inspection.store';
export * from './node-level.store';
export * from './subcontractor.store';
export * from './unit.store';

export const SHARED_STORES = [
  AliasStoreService,
  RoleStoreService,
  ActionByStoreService,
  PriorityStoreService,
  DisciplineStoreService,
  LocationProjectStoreService,
  TagsStoreService,
  InspectionTypeStoreService,
  StatusStoreService,
  SourcesStoreService,
  LiveReportsStoreService,
  TemplateTypeStoreService,
  PunchesTemplatesStoreService,
  StatusInspectionStoreService,
  NodeLevelStoreService,
  SubcontractorStoreService,
  UnitStoreService,
];
